import ArrowLeft from "@/components/Svg/ArrowLeft";
import { DataBannerTypes } from "@/types/BannerType";
import Image from "next/image";
import Link from "next/link";
import React from "react";

function OneBanner({ dataTemplate }: DataBannerTypes) {
  const singleBannerLink = `pt-[60%] sm:pt-[25%] rounded-[1rem]  sm:rounded-[1.5rem]  lg:rounded-3xl relative  overflow-hidden`;
  const singleBannerImageClass = `w-full h-full object-cover rounded-[1rem sm:rounded-[1.5rem] lg:rounded-3xl absolute inset-0 hover:filter z-20 hover:blur-[2px] transition-all duration-300`;
  const singleBannerParentSpan = `absolute bottom-0 flex  items-end justify-center z-30  w-full rounded-b-2xl lg:rounded-b-3xl  h-max text-white md:text-lg sm:text-lg text-base lg:text-3xl`;
  const singleBannerSpan = `lg:p-10 p-6   text-right  flex  items-center gap-2 lg:gap-6    w-full bg-gradient-to-t z-30 from-[#1A1818] to-transparent `;
  const singleBannerArrow = `stroke-[#FFC20A]`;
  return (
    <div className="grid grid-cols-1 my-5 lg:px-16 px-6">
      <Link href={dataTemplate?.[0]?.link ?? "/"} className={singleBannerLink}>
        <Image
          priority
          fetchPriority="high"
          sizes="100vw"
          unoptimized
          src={dataTemplate?.[0]?.patchImage ?? "/images/default.png"}
          quality={100}
          width={5000}
          height={3000}
          className={singleBannerImageClass}
          alt="banner-1"
        />
        <span className={singleBannerParentSpan}>
          <span className={singleBannerSpan}>
            {dataTemplate?.[0]?.title}
            <ArrowLeft className={singleBannerArrow} />
          </span>
        </span>
      </Link>
    </div>
  );
}

export default OneBanner;
